import { render, staticRenderFns } from "./Blogs.vue?vue&type=template&id=984cd58c&scoped=true"
import script from "./Blogs.vue?vue&type=script&lang=ts"
export * from "./Blogs.vue?vue&type=script&lang=ts"
import style0 from "./Blogs.vue?vue&type=style&index=0&id=984cd58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984cd58c",
  null
  
)

export default component.exports